import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne'
import NavBar from '../nav_bar/Navbar'
import LeadCreate from './LeadCreate'

function Lead() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadCreate/>}
                menuId={11}
            />
        </DataContext.Provider>
    )
}

export default Lead